import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHero, Section, SectionHead } from "@/components/sections";
import { Reveal } from "@/components/Reveal";
import { GOALS } from "@/constants/goals";

export default function Goals() {
  return (
    <div>
      <SEO
        title="Goal Planning — Calculators & Free Guides | Rao Investment Solutions"
        description="Plan retirement, your child's education or your first ₹1 crore. Free goal calculators, personalised reports and guides."
        path="/goals"
      />
      <PageHero
        label="Goal planning"
        title="Every goal deserves its own plan."
        intro="Pick a goal. Get an illustrative plan in a minute, a personalised PDF report and a free guide."
        breadcrumbs={[{ name: "Home", to: "/" }, { name: "Goals" }]}
      />
      {[
        { key: "individual", label: "For individuals & families", title: "Plan a life goal" },
        { key: "business", label: "For businesses & owners", title: "Plan for your business" },
      ].map((grp, gi) => {
        const items = GOALS.filter((g) => g.audience === grp.key);
        return (
          <Section key={grp.key} cream={gi === 0}>
            <SectionHead label={grp.label} title={grp.title} />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((g, i) => (
            <Reveal key={g.slug} delay={i * 0.05}>
              <Link
                to={`/goals/${g.slug}`}
                className="group flex flex-col h-full bg-white shadow-elevated border border-navy/5 hover:shadow-floating focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-citrine transition-shadow duration-300"
                data-testid={`goals-card-${g.slug}`}
              >
                <img src={g.ebook.cover} alt="" aria-hidden="true" className="w-full aspect-[16/9] object-cover object-[50%_50%]" loading="lazy" />
                <div className="p-8 flex flex-col gap-3 flex-1 border-t-2 border-citrine">
                  <div className="font-sans text-xs uppercase tracking-[0.2em] text-slate">{g.hero.label}</div>
                  <div className="font-serif text-3xl text-navy tracking-[-0.02em]">{g.name}</div>
                  <p className="font-sans text-sm text-slate leading-[1.7]">Calculator · personalised report · free guide: <em>{g.ebook.title}</em></p>
                  <div className="mt-auto pt-4 inline-flex items-center gap-2 font-sans text-sm text-orange">
                    Plan this goal <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
          </Section>
        );
      })}
    </div>
  );
}
